import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { URLBuilder } from "../url";
/**
 * Methods that are allowed to follow redirects 301 and 302
 */

var allowedRedirect = ["GET", "HEAD"];
export var DefaultRedirectOptions = {
  handleRedirects: true,
  maxRetries: 20
};
/**
 * Creates a redirect policy, which sends a repeats the request to a new destination if a response arrives with a "location" header, and a status code between 300 and 307.
 * @param maximumRetries - Maximum number of redirects to follow.
 * @returns An instance of the {@link RedirectPolicy}
 */

export function redirectPolicy() {
  var maximumRetries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  return {
    create: function create(nextPolicy, options) {
      return new RedirectPolicy(nextPolicy, options, maximumRetries);
    }
  };
}
/**
 * Resends the request to a new destination if a response arrives with a "location" header, and a status code between 300 and 307.
 */

export var RedirectPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(RedirectPolicy, _BaseRequestPolicy);

  var _super = _createSuper(RedirectPolicy);

  function RedirectPolicy(nextPolicy, options) {
    var _this;

    var maxRetries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

    _classCallCheck(this, RedirectPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.maxRetries = maxRetries;
    return _this;
  }

  _createClass(RedirectPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this._nextPolicy.sendRequest(request).then(function (response) {
        return handleRedirect(_this2, response, 0);
      });
    }
  }]);

  return RedirectPolicy;
}(BaseRequestPolicy);

function handleRedirect(policy, response, currentRetries) {
  var request = response.request,
      status = response.status;
  var locationHeader = response.headers.get("location");

  if (locationHeader && (status === 300 || status === 301 && allowedRedirect.includes(request.method) || status === 302 && allowedRedirect.includes(request.method) || status === 303 && request.method === "POST" || status === 307) && (!policy.maxRetries || currentRetries < policy.maxRetries)) {
    var builder = URLBuilder.parse(request.url);
    builder.setPath(locationHeader);
    request.url = builder.toString(); // POST request with Status code 303 should be converted into a
    // redirected GET request if the redirect url is present in the location header

    if (status === 303) {
      request.method = "GET";
      delete request.body;
    }

    return policy._nextPolicy.sendRequest(request).then(function (res) {
      return handleRedirect(policy, res, currentRetries + 1);
    });
  }

  return Promise.resolve(response);
}